if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('touchstart', (event) => this.startPhotoTap(event), { passive: true });
        this.addEventListener('touchmove', (event) => this.movePhotoTap(event), { passive: true });
        this.addEventListener('touchend', (event) => this.finishPhotoTap(event), { passive: false });
        this.addEventListener('touchstart', (event) => this.startPhotoPinch(event), { passive: false });
        this.addEventListener('touchmove', (event) => this.movePhotoPinch(event), { passive: false });
        this.addEventListener('touchend', (event) => { this.finishPhotoSwipe(event); this.photoPinch = null; });
        this.addEventListener('touchcancel', () => { this.photoPinch = null; this.photoSwipe = null; this.photoTap = null; this.lastPhotoTap = null; });
        this.addEventListener('touchstart', (event) => this.startPhotoSwipe(event), { passive: true });
        this.addEventListener('touchmove', (event) => this.movePhotoSwipe(event), { passive: false });
      }

      hide() {
        this.resetPhotoZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      resetPhotoZoom() {
        this.photoTap = null;
        this.lastPhotoTap = null;
        this.doubleTapZoomed = false;
        this.photoPinch = null;
        this.photoSwipe = null;
        if (!this.zoomedPhoto) return;
        const { image, style } = this.zoomedPhoto;
        if (style === null) image.removeAttribute('style');
        else image.setAttribute('style', style);
        this.zoomedPhoto = null;
      }

      startPhotoTap(event) {
        this.photoTap = null;
        if (event.touches.length !== 1) { this.lastPhotoTap = null; return; }
        if (!this.hasAttribute('open') || !matchMedia('(max-width: 749px)').matches) return;
        const image = this.querySelector('img.active');
        if (!image || event.target !== image) return;
        const touch = event.touches[0];
        this.photoTap = { image, x: touch.clientX, y: touch.clientY, time: Date.now() };
      }

      movePhotoTap(event) {
        if (!this.photoTap) return;
        if (event.touches.length !== 1 ||
            Math.hypot(event.touches[0].clientX - this.photoTap.x, event.touches[0].clientY - this.photoTap.y) > 12) {
          this.photoTap = null;
          this.lastPhotoTap = null;
        }
      }

      finishPhotoTap(event) {
        const tap = this.photoTap;
        this.photoTap = null;
        if (!tap || event.touches.length || Date.now() - tap.time > 250) return;
        const previous = this.lastPhotoTap;
        this.lastPhotoTap = tap;
        if (!previous || previous.image !== tap.image || tap.time - previous.time > 350 ||
            Math.hypot(tap.x - previous.x, tap.y - previous.y) > 35) return;
        event.preventDefault();
        this.lastPhotoTap = null;
        this.photoSwipe = null;
        const image = tap.image;
        const container = this.querySelector('[role="document"]');
        const rect = image.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        if (!this.zoomedPhoto) this.zoomedPhoto = { image, style: image.getAttribute('style'), baseWidth: rect.width };
        const fitWidth = Math.min(container.clientWidth, (window.innerHeight - 80) * rect.width / rect.height);
        const zoomOut = this.doubleTapZoomed;
        const width = zoomOut ? fitWidth : Math.min(this.zoomedPhoto.baseWidth * 3, Math.max(rect.width * 2, fitWidth * 2));

        Object.assign(image.style, { width: width + 'px', height: 'auto', maxWidth: 'none', maxHeight: 'none' });
        this.doubleTapZoomed = !zoomOut;
        this.centerPhoto(container);

      }

      startPhotoPinch(event) {
        if (event.touches.length !== 2 || !this.hasAttribute('open') || !matchMedia('(max-width: 749px)').matches) return;
        const image = this.querySelector('img.active');
        const container = this.querySelector('[role="document"]');
        if (!image || !container || !container.contains(event.target)) return;
        const [a, b] = event.touches;
        const distance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        const rect = image.getBoundingClientRect();
        if (!distance || !rect.width || !rect.height) return;
        if (!this.zoomedPhoto) this.zoomedPhoto = { image, style: image.getAttribute('style'), baseWidth: rect.width };
        this.photoPinch = {
          image, container, distance, width: rect.width,
          x: ((a.clientX + b.clientX) / 2 - rect.left) / rect.width,
          y: ((a.clientY + b.clientY) / 2 - rect.top) / rect.height
        };
        event.preventDefault();
      }

      movePhotoPinch(event) {
        if (!this.photoPinch || event.touches.length !== 2) return;
        event.preventDefault();
        const [a, b] = event.touches;
        const p = this.photoPinch;
        const distance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        const base = this.zoomedPhoto.baseWidth;
        const width = Math.max(100, Math.min(base * 3, p.width * distance / p.distance));
        Object.assign(p.image.style, { width: width + 'px', height: 'auto', maxWidth: 'none', maxHeight: 'none' });
        this.centerPhoto(p.container);
      }

      centerPhoto(container) {
        container.scrollLeft = Math.max(0, (container.scrollWidth - container.clientWidth) / 2);
        container.scrollTop = Math.max(0, (container.scrollHeight - container.clientHeight) / 2);
      }

      startPhotoSwipe(event) {
        this.photoSwipe = null;
        if (event.touches.length !== 1 || !this.hasAttribute('open') || !matchMedia('(max-width: 749px)').matches) return;
        const image = this.querySelector('img.active');
        const container = this.querySelector('[role="document"]');
        if (!image || !container.contains(event.target)) return;
        // Keep one-finger panning available after zooming beyond the opening size.
        if (this.zoomedPhoto && image.getBoundingClientRect().width > this.zoomedPhoto.baseWidth + 1) return;
        this.photoSwipe = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }

      movePhotoSwipe(event) {
        if (!this.photoSwipe || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - this.photoSwipe.x;
        const dy = event.touches[0].clientY - this.photoSwipe.y;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.5) event.preventDefault();
      }

      finishPhotoSwipe(event) {
        const start = this.photoSwipe;
        this.photoSwipe = null;
        if (!start || event.touches.length || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        const photos = Array.from(this.querySelectorAll('[role="document"] > img[data-media-id]'));
        const index = photos.findIndex((image) => image.classList.contains('active'));
        if (index < 0 || photos.length < 2) return;
        const next = photos[(index + (dx < 0 ? 1 : -1) + photos.length) % photos.length];
        this.showActiveMedia(next.getAttribute('data-media-id'));
      }

      showActiveMedia(mediaId = this.openedBy.getAttribute('data-media-id')) {
        this.resetPhotoZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
